define(['text!./templates/custom-quote.html',
        'edge/quoteandbind/common/app'
    ],
    (templateStr)=> {
        return ['$window', '$timeout', function ($window, $timeout) {
            return {
                restrict: 'A',
                template: templateStr,
                require: 'gwQnbCustomQuote',
                scope: {
                    standardOffering: '=',
                    customQuote: '=',
                    buy: '=',
                    sessionid: '=',
                    submissionid: '='
                },
                controller: ['$scope', 'qnb.CustomQuoteService', '$q', '$filter', 'ModalService', 'ViewModelService',
                    function ($scope, CustomQuoteService, $q, $filter, ModalService, ViewModelService) {
                        const self = this;

                        $scope.view = ViewModelService.create($scope.customQuote, 'pc', 'edge.capabilities.quote.quoting.dto.QuoteDTO');

                        $scope.syncCoverage = ()=> {
                            $scope.quoteStatus.isStale = true;
                            if (!self._validateInputFields()) {
                                return;
                            }

                            $scope.quoteStatus.showLoading = true;
                            $scope.quoteStatus.calculatingQuote = true;
                            const operation = CustomQuoteService.updateCustomQuoteCoverages('quoteandbind', $scope.customQuote, $scope.sessionid, $scope.submissionid);
                            operation.then((quote)=> {
                                $scope.customQuote = quote;
                            });
                            operation.catch(self._handleQuoteError);
                            operation.finally(()=> {
                                $scope.quoteStatus.showLoading = false;
                                $scope.quoteStatus.calculatingQuote = false;
                                $scope.CustomQuoteForm.submitted = false;
                            });
                        };

                        $scope.markStale = ()=> {
                            $scope.quoteStatus.isStale = true;
                        };

                        $scope.buyQuote = function () {
                            if (!self._validateInputFields()) {
                                return;
                            }
                            $scope.buy.apply(null, arguments);
                        };

                        $scope.buyQuoteWithDefaultParams = ()=> {
                            const termInMonths = $scope.customQuote.termMonths;
                            $scope.buy($scope.customQuote, termInMonths);
                        };


                        this.updateQuote = ()=> {
                            if (!self._validateInputFields()) {
                                return;
                            }

                            $scope.quoteStatus.calculatingQuote = true;
                            $scope.quoteStatus.showLoading = true;

                            const operation = CustomQuoteService.updateCustomQuote('quoteandbind', $scope.customQuote, $scope.sessionid, $scope.submissionid);
                            operation.then((updatedCustomQuote)=> {
                                $scope.customQuote.lobs = updatedCustomQuote.lobs;
                                $scope.customQuote.total = updatedCustomQuote.total;
                                $scope.customQuote.monthlyPremium = updatedCustomQuote.monthlyPremium;
                                $scope.customQuote.totalBeforeTaxes = updatedCustomQuote.totalBeforeTaxes;
                                $scope.customQuote.taxes = updatedCustomQuote.taxes;
                                $scope.customQuote.hasBlockingUWIssues = updatedCustomQuote.hasBlockingUWIssues;
                                $scope.quoteStatus.isStale = false;
                            });
                            operation.catch(self._handleQuoteError);
                            operation.finally(()=> {
                                $scope.quoteStatus.calculatingQuote = false;
                                $scope.quoteStatus.showLoading = false;
                                $scope.CustomQuoteForm.submitted = false;
                            });
                        };

                        this._handleQuoteError = (error)=> {
                            const message = $filter('translate')('integration.quoteandbind.directives.custom-quote.Invalid Coverage Option');
                            const description = $filter('translate')('integration.quoteandbind.directives.custom-quote.Sorry, but that coverage option is invalid, please select a different value');
                            ModalService.showError(message, description);
                            console.log('Error updating custom quote', error);
                        };

                        /**
                         * Checks that there are no invalid inputs or nested forms, displays a modal prompting the user to
                         * fix errors.
                         *
                         * @returns {boolean}
                         */
                        this._validateInputFields = ()=> {
                            if (!$scope.view.aspects.subtreeValid) {
                                const message = $filter('translate')('integration.quoteandbind.directives.custom-quote.Invalid input values');
                                const description = $filter('translate')('integration.quoteandbind.directives.custom-quote.Please correct input field errors');
                                ModalService.showError(message, description);
                                $scope.CustomQuoteForm.submitted = true;
                                return false;
                            }
                            //If the form is valid then reset the submitted value. So pristine fields are not marked with errors
                            $scope.CustomQuoteForm.submitted = false;
                            return true;
                        };

                        $scope.quoteStatus = {
                            calculatingQuote: false,
                            showLoading: false,
                            displayed: false,
                            isStale: false
                        };

                        $scope.$on('CustomQuoteSelected', ()=> {
                            //have to wait until custom tab is selected and tab contents are visible
                            $timeout(()=> {
                                $scope.quoteStatus.displayed = true;
                            }, 50);
                        });

                        // If there is no standard offering then the custom quote content must be visible
                        if (!angular.isDefined($scope.standardOffering)) {
                            $scope.quoteStatus.displayed = true;
                        }

                        $scope.updateQuote = this.updateQuote;
                    }],
                'link': (scope, elt)=> {
                    elt[0].addEventListener('change', ()=> {
                        scope.quoteStatus.isStale = true;
                    });
                }
            };
        }];
    }
);



// WEBPACK FOOTER //
// ../common/js/src/integration/quoteandbind/directives/CustomQuote.js